import Vue from 'vue'
import { getUser } from '@/lib/auth'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

export function sentrySetup(router) {
  // Sentry init
  Sentry.init({
    Vue,
    dsn: "https://bf357f42025646678968944f690c5828@sentry.io/1313055",
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "dashboard.leaf.ai", /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

export function setUserContext() {
  let user = getUser()

  if (user) {
    Sentry.configureScope((scope) => {
      scope.setUser({
        "id": user.id,
        "email": user.email
      })
    })
  }
}
